// extracted by mini-css-extract-plugin
module.exports = {"signatureLink":"CorrespondingDocumentSection_signatureLink__2B5uS"};